import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-2xl text-background-50">
              狠狠爱
            </Link>
            <p className="mt-4 text-sm text-background-300 leading-relaxed">
              不顾一切、全力以赴的爱。<br />
              让每一份情感都燃烧得更有意义。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-background-50 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-background-50 transition-colors duration-200">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors duration-200">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/love-yourself" className="text-sm text-background-300 hover:text-background-50 transition-colors duration-200">
                  狠狠爱自己
                </Link>
              </li>
              <li>
                <Link to="/category/love-someone" className="text-sm text-background-300 hover:text-background-50 transition-colors duration-200">
                  狠狠爱一个人
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line"></i>
                </span>
                <span>hello@henhenai.com</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line"></i>
                </span>
                <span>中国 · 北京</span>
              </li>
            </ul>
            <div className="flex items-center gap-4 mt-5">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="小红书">
                <i className="ri-reddit-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/60 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 狠狠爱. 保留所有权利.
          </p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <a href="#" className="hover:text-background-200 transition-colors duration-200">隐私政策</a>
            <a href="#" className="hover:text-background-200 transition-colors duration-200">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}